export interface VideoTutorial {
    id: number;
    title: string;
    /**
     * YouTube video ID — upload the videos as "Unlisted" on YouTube
     * and paste the 11-character ID from the URL here.
     * Example URL: https://www.youtube.com/watch?v=dQw4w9WgXcQ → "dQw4w9WgXcQ"
     */
    youtubeId: string;
}

export const VIDEO_TUTORIALS: VideoTutorial[] = [
    { id: 0, title: 'Introduction to pre-project analysis', youtubeId: '9WvKMc0R0bU' },
    { id: 1, title: 'IpOp Tools Fundamentals', youtubeId: 'DEOlOGxIIpU' },
    { id: 2, title: 'IpOp Reviews Iterations', youtubeId: 'Mr4sOXJ3l1I' },
    { id: 3, title: 'Quick Action Buttons', youtubeId: 'nZBMzXDwgDg' },
    { id: 4, title: 'Input Reliability (confidence)', youtubeId: 'V6jCxgIp1aI' },
    { id: 5, title: 'IpOp Tools Best Practices', youtubeId: '7h7EHvZfh2s' }
];

export const INTRO_VIDEO_SEEN_KEY = 'ipop:intro_video_seen';

export const isIntroVideoSeen = (): boolean => {
    try {
        return window.localStorage.getItem(INTRO_VIDEO_SEEN_KEY) === '1';
    } catch {
        return false;
    }
};

export const markIntroVideoSeen = (): void => {
    try {
        window.localStorage.setItem(INTRO_VIDEO_SEEN_KEY, '1');
    } catch {
        // localStorage unavailable (private mode, quota) — silently ignore
    }
};

export const getVideoById = (id: number): VideoTutorial | undefined =>
    VIDEO_TUTORIALS.find((v) => v.id === id);

export const isPlaceholderVideo = (video: VideoTutorial): boolean =>
    video.youtubeId.startsWith('TODO_');
